<template>
  <v-card class="customer-dashboard-card">
    <v-card-title class="customer-dashboard-header">
      <slot name="tabs" />
      <article class="customer-kpi customer-kpi--total">
        <span class="customer-kpi__icon">
          <v-icon>people</v-icon>
        </span>
        <span class="customer-kpi__body">
          <span class="customer-kpi__label">Total Customers</span>
          <strong class="customer-kpi__value">{{ dashboard.total }}</strong>
        </span>
        <span class="customer-kpi__meta">All time</span>
      </article>

      <article class="customer-kpi customer-kpi--today">
        <span class="customer-kpi__icon">
          <v-icon>event</v-icon>
        </span>
        <span class="customer-kpi__body">
          <span class="customer-kpi__label">Customers Today</span>
          <strong class="customer-kpi__value">{{ dashboard.today }}</strong>
        </span>
        <!-- <span class="customer-kpi__meta">{{ todayLabel }}</span> -->
      </article>

      <div class="customer-dashboard-actions">
        <button
          v-permissions="'add-new-customer'"
          class="customer-header-btn customer-header-btn--secondary"
          type="button"
          v-if="selectedCustomer.length && tabFilter == 'true'"
          @click="CheckboxSelectedIb()"
        >
          <v-icon>sync_alt</v-icon>
          Send Data To IB
        </button>
        <button
          v-permissions="'add-new-customer'"
          class="customer-header-btn customer-header-btn--secondary"
          type="button"
          v-if="!selectedCustomer.length && tabFilter == 'true'"
          @click="SendIBPopup()"
        >
          <v-icon>sync_alt</v-icon>
          Send Data IB
        </button>
        <button
          v-permissions="'add-new-customer'"
          class="customer-header-btn customer-header-btn--primary"
          type="button"
          @click="check()"
        >
          <v-icon>add</v-icon>
          Add New Customer
        </button>
      </div>
    </v-card-title>
    <SelectCountry
      :open="selectCountryDialog"
      @closeSelectCountry="selectCountryDialog = false"
      :type="'/customer/new'"
    />

    <v-dialog
      v-model="dialog"
      persistent
      max-width="34rem"
      content-class="customer-ib-dialog"
    >
      <v-card class="comments-view customer-ib-dialog-card">
        <v-toolbar class="customer-ib-dialog-toolbar" flat>
          <v-toolbar-title>Select Send Data To IB</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="customer-ib-dialog-close" icon @click.prevent="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-spacer class="invoice-pop customer-ib-dialog-content">
          <v-card-text class="nospace customer-ib-dialog-body">
            <v-layout class="customer-ib-options-row">
              <v-flex>
                <v-radio-group
                  class="customer-ib-radio-group"
                  v-model="selected"
                  mandatory
                >
                  <v-radio
                    label="Enable All Customer IB"
                    class="customer-ib-radio"
                    color="red"
                    value="ADD_TO_REAL_BOOK"
                  ></v-radio>

                  <v-radio
                    label="Disable All Customer IB"
                    value="REMOVE_FROM_REAL_BOOK"
                    class="customer-ib-radio"
                    color="red"
                  ></v-radio>
                  <v-radio
                    label="Enable/Disable Customer Manually"
                    value="openCheckBox"
                    class="customer-ib-radio"
                    color="red"
                  ></v-radio>

                  <!--
                    <v-radio
                      label="Single Line Invoice For Multiple Jobs"
                      class="boxborder"
                      value="singleLineWithMultipleJobsBasis"
                      color="red"
                      :disabled="jobIds.length == 1"
                    ></v-radio> -->
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout class="customer-ib-dialog-actions">
              <v-spacer />
              <v-btn
                class="customer-ib-secondary-action"
                size="large"
                flat
                @click.native="close"
                >Cancel</v-btn
              >

              <v-btn
                class="oms-btn oms-btn--primary customer-ib-primary-action"
                flat
                target="_blank"
                @click="chooseDataForIb()"
                prepend-icon
                color="white darken-1"
              >
                Yes</v-btn
              >
            </v-layout>
          </v-card-text>
        </v-spacer>
      </v-card>
      <v-snackbar
        :timeout="4000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-dialog>
    <v-dialog
      v-model="dialogIb"
      persistent
      max-width="34rem"
      content-class="customer-ib-dialog"
    >
      <v-card class="comments-view customer-ib-dialog-card">
        <v-toolbar class="customer-ib-dialog-toolbar" flat>
          <v-toolbar-title>Select Send Data To IB</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="customer-ib-dialog-close" icon @click.prevent="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-spacer class="invoice-pop customer-ib-dialog-content">
          <v-card-text class="nospace customer-ib-dialog-body">
            <v-layout class="customer-ib-options-row">
              <v-flex>
                <v-radio-group
                  class="customer-ib-radio-group"
                  v-model="selectedIbRadio"
                  mandatory
                >
                  <v-radio
                    label="Enable customer to send the data to IB"
                    class="customer-ib-radio"
                    color="red"
                    value="ADD_TO_REAL_BOOK"
                  ></v-radio>

                  <v-radio
                    label="Disable customer to send the data to IB"
                    value="REMOVE_FROM_REAL_BOOK"
                    class="customer-ib-radio"
                    color="red"
                  ></v-radio>

                  <!--
                    <v-radio
                      label="Single Line Invoice For Multiple Jobs"
                      class="boxborder"
                      value="singleLineWithMultipleJobsBasis"
                      color="red"
                      :disabled="jobIds.length == 1"
                    ></v-radio> -->
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout class="customer-ib-dialog-actions">
              <v-spacer />
              <v-btn
                class="customer-ib-secondary-action"
                size="large"
                flat
                @click.native="close"
                >Cancel</v-btn
              >

              <v-btn
                class="oms-btn oms-btn--primary customer-ib-primary-action"
                flat
                target="_blank"
                @click="SendSelectedCustomer()"
                prepend-icon
                color="white darken-1"
              >
                Yes</v-btn
              >
            </v-layout>
          </v-card-text>
        </v-spacer>
      </v-card>
      <v-snackbar
        :timeout="4000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-dialog>
  </v-card>
</template>
<script>
import SelectCountry from "../Common/SelectCountry";
import { StorageKeys } from "../../constants/constants";
import { ApiService } from "@/services/api-service";
export default {
  components: {
    SelectCountry,
  },
  props: ["dashboard", "selectedCustomerIb", "tabFilter"],
  data() {
    return {
      selectCountryDialog: false,
      error: "",
      dialog: false,
      dialogIb: false,
      showIbDetails: false,
      operationName: "",
      selected: [],
      selectedIbRadio: [],
      selectedCustomer: [],
    };
  },
  computed: {
    /* e.g. "15 Oct", so the tile says which day it counts. */
    todayLabel() {
      return new Date().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
      });
    },
  },
  watch: {
    selectedCustomerIb(e) {
      this.selectedCustomer = e;
    },
  },
  methods: {
    async check() {
      this.operationName = "add-new-customer";
      let y = await this.checkOpertaionPermission(this.operationName);

      if (y) {
        if (localStorage.getItem("workingCountries")) {
          this.workingCountries = JSON.parse(
            localStorage.getItem("workingCountries")
          );
          let workingCountry = [];
          this.workingCountries.forEach((key, index) => {
            if (key.isSelected) {
              workingCountry.push(key.value);
            }
          });
          if (workingCountry.length === 1) {
            this.$router.push(`/customer/new`);
          } else {
            this.selectCountryDialog = true;
          }
        }
      } else {
        return;
      }
    },

    SendIBPopup() {
      this.dialog = true;
    },
    close() {
      this.selected = [];
      this.selectedIbRadio = [];
      this.loading = false;
      this.dialog = false;
      this.dialogIb = false;
    },
    SendSelectedCustomer() {
      this.$eventBus.$emit("on-load");
      if (!this.selectedIbRadio.length) {
        this.error = "Please Select  Any Method For Send Data To IB !";
        return;
      }
      let url = "/dmsAdmin/update-ib-access-status";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        // custId: id.toString(),
        type: "ONE",
        usersIds: this.selectedCustomer,
        action: this.selectedIbRadio,
      };

      this.axios
        .put(this.constants.apiUrl + url, body, config)
        .then((response) => {
          this.dialogIb = false;
          this.$eventBus.$emit("off-load");
          this.$emit("checkBoxShow", false);
          this.selected = [];
          this.selectedIbRadio = [];
          this.selectedCustomer = [];
          this.$emit("resetIb");
          this.$emit("refreshIb");
        });
    },
    chooseDataForIb() {
      if (!this.selected.length) {
        this.error = "Please Select  Any Method For Send Data To IB !";
        return;
      } else {
        if (this.selected == "openCheckBox") {
          this.$emit("checkBoxShow", true);
          this.dialog = false;
        } else {
          let url = "/dmsAdmin/update-ib-access-status";
          delete this.axios.defaults.headers.common["token"];
          let token = localStorage.getItem(StorageKeys.SessionKey);
          let config = {
            headers: {
              authorization: `bearer ${token}`,
            },
          };
          let body = {
            // custId: id.toString(),
            type: "ALL",
            action: this.selected,
          };

          this.axios.put(this.constants.apiUrl + url, body, config).then(
            (response) => {
              this.dialog = false;
              this.selected = [];
            },
            (error) => {}
          );
        }
      }
    },

    CheckboxSelectedIb() {
      this.dialogIb = true;
    },
  },
};
</script>
<style scoped>
.dashboard {
  padding: 20px;
  margin: 0 auto;
}
.breakword {
  padding: 10px;
}
.p-b-0 {
  padding-bottom: 0 !important;
}

.f-16 {
  font-size: 16px !important;
}
.invoice-pop {
  padding: 20px !important;
}
.fonthead {
  font-size: 20px;
}
</style>
<style lang="scss">
.customer-ib-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.customer-ib-dialog-card.comments-view {
  background: var(--oms-surface, #ffffff) !important;
  border-radius: 12px !important;
  overflow: hidden;
}

.customer-ib-dialog-toolbar.v-toolbar {
  background: var(--oms-primary-soft, #fff7ed) !important;
  border-bottom: 1px solid #fed7aa !important;
  box-shadow: none !important;
  min-height: 64px;
}

.customer-ib-dialog-toolbar .v-toolbar__content {
  min-height: 64px;
  padding: 0 24px !important;
}

.customer-ib-dialog-toolbar .v-toolbar__title {
  color: var(--oms-primary-dark, #d96a10) !important;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
}

.customer-ib-dialog-close {
  color: var(--oms-ink, #3a382f) !important;
}

/* Match the toolbar's 24px horizontal padding so title, options and buttons line up */
.customer-ib-dialog-content.invoice-pop {
  padding: 0 !important;
}

.customer-ib-dialog-body {
  overflow-x: hidden !important;
  padding: 8px 24px 20px !important;
}

.customer-ib-radio-group {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

/* Strip Vuetify's default radio-group spacing (top margin, slot margin, messages area)
   so there is no stray gap between the last option and the action buttons */
.customer-ib-radio-group.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.customer-ib-radio-group .v-input__control {
  width: 100%;
}

.customer-ib-radio-group .v-input__slot {
  margin-bottom: 0 !important;
}

.customer-ib-radio-group .v-messages {
  display: none;
}

.customer-ib-radio-group .v-input--radio-group__input {
  width: 100%;
}

.customer-ib-radio.customer-ib-radio:last-child {
  border-bottom: none;
}

.customer-ib-radio.customer-ib-radio {
  align-items: center;
  border-bottom: 1px solid var(--oms-border, #ebe9e2);
  display: flex;
  margin: 0 !important;
  min-height: 56px;
  padding: 12px 0 !important;
  width: 100%;
}

/* Keep Vuetify's relative positioning: the hidden <input> inside is absolute
   with width/height 100%, and a static wrapper lets it stretch to a far wider
   ancestor, which caused the dialog's horizontal scrollbar. */
.customer-ib-radio .v-input--selection-controls__input {
  flex: 0 0 auto;
  margin-left: 16px;
  order: 2;
  position: relative !important;
  right: auto !important;
}

.customer-ib-radio .v-label {
  color: var(--oms-ink, #3a382f) !important;
  flex: 1 1 auto;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  max-width: none;
  min-width: 0;
  overflow-wrap: anywhere;
  padding-right: 12px;
  white-space: normal;
}

.customer-ib-dialog-actions {
  align-items: center;
  border-top: 1px solid var(--oms-border, #ebe9e2);
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 16px;
}

.customer-ib-dialog-actions .v-btn {
  margin: 0 !important;
}

.customer-ib-secondary-action,
.customer-ib-primary-action {
  border-radius: 10px !important;
  font-weight: 800 !important;
  min-height: 40px !important;
  min-width: 84px !important;
  text-transform: none !important;
}

.customer-ib-secondary-action {
  background: transparent !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  color: var(--oms-primary, #ea7a1c) !important;
}

.customer-ib-primary-action {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.customer-ib-primary-action .v-btn__content {
  color: #ffffff !important;
}
</style>
